module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/setpublish-7174e7b8e08d64828bb99f01e7b27497.png";